'use strict';

import React, { Component } from 'react';

import LocalizacionRow from './LocalizacionRow';

import ModalContenedor  from './Modales/ModalContenedor';

class Localizacion extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const {data, formasComunicacion, domicilios, domicilioComponentes, actions, permisoModificacion, permisoAlta, permisoBaja} = this.props;

        const telefonos = formasComunicacion ? formasComunicacion.filter(forma=>forma.MedioNombre == "TELEFONICO") : [];
        const email = formasComunicacion ? formasComunicacion.filter(forma=>forma.MedioNombre=="ELECTRONICO") : [];
        
        const postal = domicilios ? domicilios : [];
        const domiciliosCombos = domicilioComponentes || [];
       
        return (
            <div>
                {data.modalAbierto && <ModalContenedor actions={actions} medio={data.modalAbierto} data={data} domiciliosCombos={domiciliosCombos} />}
                <div className='firaSansExtraLightTitulo'>
                    Localización
                </div>
                {data.loading_cliente ?<div className="loadingSmall"></div> : <div className="row top-separator-xs">
                    <div className="col-md-12">
                        {<table className="table tdSolicitudes localizacionClienteTable">
                            <thead>
                                <tr>
                                    <th width="110px">LEGAL</th>
                                    <th width="110px">CORRESP.</th>
                                    <th width="640px">DOMICILIOS POSTALES</th>
                                    {/* <th>ACCIONES  {permisoAlta && <span onClick={()=>actions.abrirModalLocalizacion("POSTAL",true)} className='iconoAgregarDiv clickable'>+</span>}</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {postal.map(pos=> <LocalizacionRow funcionEliminar={actions.eliminarMedioDeContacto} permisoBaja={permisoBaja} permisoModificacion={permisoModificacion} funcionModificar={actions.modificarCampoLocalizacion} medio={pos} domiciliosCombos={domiciliosCombos} />)}
                            </tbody>
                        </table>}
                    {<table className="table tdSolicitudes localizacionClienteTable">
                            <thead>
                                <tr>
                                    <th width="110px">LEGAL</th>
                                    <th width="110px">CORRESP.</th>
                                    <th width="550px">DIRECCIONES ELECTRÓNICAS</th>
                                    <th width="90px">TIPO</th>
                                    {/* <th >ACCIONES  {permisoAlta && <span onClick={()=>actions.abrirModalLocalizacion("EMAIL",true)} className='iconoAgregarDiv clickable'>+</span>}</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {email.map(mail=> <LocalizacionRow permisoBaja={permisoBaja} permisoModificacion={permisoModificacion} funcionEliminar={actions.eliminarMedioDeContacto} funcionModificar={actions.modificarCampoLocalizacion} medio={mail} />)}
                            </tbody>
                        </table>}
                        {<table className="table tdSolicitudes localizacionClienteTable">
                            <thead>
                                <tr>
                                    <th width="110px">PRODUCTOS</th>
                                    <th width="110px"></th>
                                    <th width="550px">TELÉFONOS</th>
                                    <th width="90px">TIPO</th>
                                    {/* <th>ACCIONES {permisoAlta && <span onClick={()=>actions.abrirModalLocalizacion("TELEFONICO",true)} className='iconoAgregarDiv clickable'>+</span>}</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {telefonos.map(tel=> <LocalizacionRow permisoBaja={permisoBaja} permisoModificacion={permisoModificacion}  funcionModificar={actions.modificarCampoLocalizacion} funcionEliminar={actions.eliminarMedioDeContacto} medio={tel} />)}
                            </tbody>
                        </table>}
                    </div>
                </div>}
            </div>
        );
    }
}

export default Localizacion;